<nav class="nav">
  <ul class="routes">
    @for (item of navigationService.FEATURES; track $index) {
    <li>
      <a
        class="route"
        [routerLink]="item.route"
        [ngClass]="{
          highlighted: item.highlighted,
          'highlighted-0': item.highlighted && $index === 0,
          'highlighted-1': item.highlighted && $index === 1,
          'highlighted-2': item.highlighted && $index === 2
        }"
      >
        <app-icon
          [icon]="item.icon"
          [width]="item.title === 'rewards' ? 18 : 20"
          [pathStroke]="
            item.highlighted && $index === 0
              ? 'var(--yellow-primary)'
              : item.highlighted && $index === 1
              ? 'var(--yellow-primary)'
              : item.highlighted && $index === 2
              ? 'var(--green-seventh)'
              : '#e04747'
          "
          [pathFill]="'transparent'"
        ></app-icon>
        {{ item.title }}
        @if(item.value){
        <span class="link-badge badge badge_red badge_rounded badge_font-l"><app-icon [icon]="'coin'" [width]="12"></app-icon> {{ item.value }}</span>
        }
      </a>
    </li>
    }
  </ul>
  <ul class="routes maintenance-routes">
    @for (item of navigationService.MAINTENANCE; track $index) {
    <li (click)="item.title === 'support' ? openSupportModal() : null">
      <a class="route" [routerLink]="item.route" [class.highlighted]="item.highlighted">
        <app-icon [icon]="item.icon" [width]="20" [pathStroke]="'#787676'"> </app-icon>
        {{ item.title }}
      </a>
      @if(item.value){
      <span class="link-badge badge badge_red badge_rounded badge_font-l">{{ item.value }}</span>
      }
    </li>
    }
  </ul>
</nav>
